import { render, staticRenderFns } from "./PeriodInfo.vue?vue&type=template&id=c71bb3f0&scoped=true"
import script from "./PeriodInfo.vue?vue&type=script&lang=js"
export * from "./PeriodInfo.vue?vue&type=script&lang=js"
import style0 from "./PeriodInfo.vue?vue&type=style&index=0&id=c71bb3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71bb3f0",
  null
  
)

export default component.exports